import { Grid } from "@mui/material";
import { VFC } from "react";
import { useTranslation } from "react-i18next";
import { getTranslationKeyOfPeriod } from "../../../domain/group/pom-announcement-period";
import { IGroupContract } from "../../../domain/group/group-contract";
import { GroupContractType } from "../../../models/group/group-contract.model";
import { formatDateShort } from "../../../utils/date.util";
import { DetailValueDisplay } from "../../value-display/detail-value-display.component";

interface IGroupContractFormDetailProps {
  baseContractValues: IGroupContract;
  pomContractValues?: IGroupContract;
}

export const GroupContractFormDetailComponent: VFC<IGroupContractFormDetailProps> = (props) => {
  const { t } = useTranslation();
  const { baseContractValues, pomContractValues } = props;
  return (
    <Grid container>
      <Grid item md={6} sm={6} xs={12}>
        <DetailValueDisplay
          label={t("basedata.groups.contractsTable.type")}
          value={baseContractValues.type ? t(`basedata.groups.contractsTable.${baseContractValues.type}Type`) : "-"}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <DetailValueDisplay
          label={t("basedata.groups.contractsTable.contract_number")}
          value={baseContractValues.contractNumber ?? "-"}
        />
      </Grid>

      <Grid item md={6} sm={6} xs={12}>
        <DetailValueDisplay
          label={t("basedata.groups.groupContracts.startDate")}
          value={baseContractValues.startDate ? formatDateShort(baseContractValues.startDate) : "-"}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <DetailValueDisplay
          label={t("basedata.groups.groupContracts.endDate")}
          value={baseContractValues.endDate ? formatDateShort(baseContractValues.endDate) : "-"}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <DetailValueDisplay
          label={t("basedata.groups.groupContracts.startDateCurrentBillingType")}
          value={baseContractValues.startDateCurrentBillingType ? formatDateShort(baseContractValues.startDateCurrentBillingType) : "-"}
        />
      </Grid>

      {baseContractValues.type === GroupContractType.Pom && pomContractValues && (
        <>
          <Grid item md={6} sm={6} xs={12}>
            <DetailValueDisplay
              label={t("basedata.groups.groupContracts.takeBackSystem")}
              value={pomContractValues.takeBackSystemName ? pomContractValues.takeBackSystemName : "-"}
            />
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <DetailValueDisplay
              label={t("basedata.groups.pom_announcement_period")}
              value={
                pomContractValues.pomAnnouncementPeriod
                  ? t(getTranslationKeyOfPeriod(pomContractValues.pomAnnouncementPeriod))
                  : "-"
              }
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
